import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"
import Address from "./Address"

export const TENANT_CONTACTS_BANKS_MAX_COUNT = 3

export interface IGetTenantContactsDto {
    contacts?: ITenantContacts | null
    links: IApiLink[]
    eTag?: string
}

export interface ITenantContacts {
    street: string
    zip: string
    city: string
    countryName: string
    vat: string
    phoneNumber: string
    faxNumber?: string | null
    email?: string | null
    banks: IGetTenantContactsBank[]
}

export default class TenantContacts {
    address: Address
    vat: string
    phoneNumber: string
    faxNumber?: string
    email?: string
    banks: TenantContactsBank[]
    eTag?: string
    linkUpdate?: IApiLink

    constructor(dto: IGetTenantContactsDto) {
        this.address = new Address({
            street: dto.contacts?.street,
            zip: dto.contacts?.zip,
            city: dto.contacts?.city,
            countryName: dto.contacts?.countryName,
        })
        this.vat = dto.contacts?.vat || ""
        this.phoneNumber = dto.contacts?.phoneNumber || ""
        this.faxNumber = dto.contacts?.faxNumber || ""
        this.email = dto.contacts?.email || ""
        this.banks = dto.contacts?.banks.map(b => new TenantContactsBank(b)) || []
        this.eTag = dto.eTag
        this.linkUpdate = dto.links.find(lnk => lnk.entity === ApiLinkEntity.tenantSettingsContacts && lnk.rel === ApiLinkRel.upsert)
    }

    get isFilled(): boolean {
        return !!this.address.street
            && !!this.address.zip
            && !!this.address.city
            && !!this.address.countryName
            && !!this.vat
            && !!this.phoneNumber
            && this.banks.length > 0
    }
}

interface IGetTenantContactsBank {
    id?: Guid | null
    ordinalNumber: number
    name: string
    iban: string
    bic: string
}

export class TenantContactsBank {
    id?: Guid
    ordinalNumber: number
    name: string
    iban: string
    bic: string

    constructor(dto: IGetTenantContactsBank) {
        this.id = dto.id || undefined
        this.ordinalNumber = dto.ordinalNumber
        this.name = dto.name
        this.iban = dto.iban
        this.bic = dto.bic
    }
}
